<div class="consultorio-privado-container">
    <form [formGroup]="form">
        @if (abaSelecionada() === EAbaConsultorioPrivado.DADOS) {
            <div class="secoes">
                <app-card-content [headerColor]="false" [title]="'Dados do Consultorio'" [icon]="iconeDaSecao('Dados do Consultorio')" [subtitle]="subtituloDaSecao('Dados do Consultorio')">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">CNES</label>
                            <input pInputText formControlName="numeroCnes" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Data do Registro</label>
                            <p-inputmask formControlName="dataRegistro" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Uso</label>
                            <p-select [appendTo]="'body'" formControlName="uso" [options]="usoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Especializado</label>
                            <p-select [appendTo]="'body'" formControlName="especialidade" [options]="yesNoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Licencas e Alvara'" [icon]="iconeDaSecao('Licencas e Alvara')" [subtitle]="subtituloDaSecao('Licencas e Alvara')">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Registro Sanitário</label>
                            <input pInputText formControlName="registroNumeroLicenca" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Tipo Registro Sanitário</label>
                            <p-select [appendTo]="'body'" formControlName="registroTipo" [options]="tipoLicencaOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Isenção Registro Sanitário</label>
                            <p-select [appendTo]="'body'" formControlName="registroIsento" [options]="yesNoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Validade Registro Sanitário</label>
                            <p-inputmask formControlName="registroValidade" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Número Alvará</label>
                            <input pInputText formControlName="alvaraNumero" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Isenção Alvará</label>
                            <p-select [appendTo]="'body'" formControlName="alvaraIsento" [options]="yesNoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Validade Alvará</label>
                            <p-inputmask formControlName="alvaraValidade" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Anexos'" [icon]="iconeDaSecao('Anexos')" [subtitle]="subtituloDaSecao('Anexos')">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <article class="campo campo--anexo">
                            <span class="campo-label">Anexo Alvará</span>
                            @if (possuiAnexoAlvara()) {
                                <button type="button" class="campo-link-botao" (click)="onVisualizarAnexoAlvara($event)" aria-label="Visualizar anexo alvará" title="Visualizar anexo alvará">
                                    <i class="pi pi-paperclip"></i>
                                    <span>Visualizar anexo</span>
                                </button>
                            } @else {
                                <strong class="campo-valor">-</strong>
                            }
                        </article>

                        <article class="campo campo--anexo">
                            <span class="campo-label">Anexo Registro Sanitário</span>
                            @if (possuiAnexoRegistroSanitario()) {
                                <button type="button" class="campo-link-botao" (click)="onVisualizarAnexoRegistroSanitario($event)" aria-label="Visualizar anexo registro sanitário" title="Visualizar anexo registro sanitário">
                                    <i class="pi pi-paperclip"></i>
                                    <span>Visualizar anexo</span>
                                </button>
                            } @else {
                                <strong class="campo-valor">-</strong>
                            }
                        </article>
                    </div>
                </app-card-content>
            </div>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.ENDERECO) {
            <div class="secoes">
                <app-card-content [headerColor]="false" [title]="'Endereco'" [icon]="iconeDaSecao('Endereco')" [subtitle]="subtituloDaSecao('Endereco')">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">CEP</label>
                            <p-inputmask formControlName="enderecoCep" mask="99999-999" placeholder="00000-000" styleClass="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Endereço</label>
                            <input pInputText formControlName="enderecoLogradouro" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Bairro</label>
                            <input pInputText formControlName="enderecoBairro" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Município</label>
                            <input pInputText formControlName="enderecoMunicipio" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Atualizado?</label>
                            <p-select [appendTo]="'body'" formControlName="enderecoAtualizado" [options]="yesNoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Permite Divulgação?</label>
                            <p-select [appendTo]="'body'" formControlName="enderecoPermiteDivulgacao" [options]="yesNoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Telefones relacionados ao endereco'" [icon]="iconeDaSecao('Telefones relacionados ao endereco')" [subtitle]="subtituloDaSecao('Telefones relacionados ao endereco')">
                    <p-table [value]="telefones" responsiveLayout="scroll">
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td>{{ getTelefoneTipoLabel(row.tipo) }}</td>
                                <td>{{ row.ddd }}</td>
                                <td>{{ row.telefone }}</td>
                                <td>{{ row.ramal }}</td>
                                <td>{{ row.observacao }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </app-card-content>
            </div>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.COMP) {
            <app-card-content [headerColor]="false" [title]="'Compartilhamento'" [icon]="iconeDaSecao('Compartilhamento')" [subtitle]="subtituloDaSecao('Compartilhamento')">
                <p-table [value]="compartilhamentos" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>UF</th>
                            <th>Nome</th>
                            <th>Entrada</th>
                            <th>Saída</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.uf }}</td>
                            <td>{{ row.nome }}</td>
                            <td>{{ row.entrada }}</td>
                            <td>{{ row.saida }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.ESP) {
            <app-card-content [headerColor]="false" [title]="'Especialidades'" [icon]="iconeDaSecao('Especialidades')" [subtitle]="subtituloDaSecao('Especialidades')">
                <p-table [value]="especialidades" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Especialidade</th>
                            <th>Área de Atuação</th>
                            <th>Data início</th>
                            <th>Data fim</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.especialidade }}</td>
                            <td>{{ row.areaAtuacao }}</td>
                            <td>{{ row.dataInicio }}</td>
                            <td>{{ row.dataFim }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaConsultorioPrivado.HORA) {
            <app-card-content [headerColor]="false" [title]="'Horarios de Funcionamento do Consultorio'" [icon]="iconeDaSecao('Horarios de Funcionamento do Consultorio')" [subtitle]="subtituloDaSecao('Horarios de Funcionamento do Consultorio')">
                <p-table [value]="horariosFuncionamento" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Dia da Semana</th>
                            <th>Horário Manhã (Início)</th>
                            <th>Horário Manhã (Fim)</th>
                            <th>Horário Tarde (Início)</th>
                            <th>Horário Tarde (Fim)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.diaSemana }}</td>
                            <td>{{ row.manhaInicio }}</td>
                            <td>{{ row.manhaFim }}</td>
                            <td>{{ row.tardeInicio }}</td>
                            <td>{{ row.tardeFim }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }
    </form>
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="anexo-feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
